import styled from 'styled-components';
import type { FunctionComponent } from 'react';
import { paletteHelper, spacingHelper, typographyHelper } from '@property.com.au/ui-kit';

interface AgentImage {
  alt: string;
  jpgUri: string;
  webpUri: string;
}

export interface PropertyTimelineAgentProps {
  name: string;
  jobTitle?: string | null;
  photo?: AgentImage | null;
}

const AgentDetailsContainer = styled.div`
  display: flex;
`;

const AgentInfo = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: ${spacingHelper('small')};
  justify-content: center;
`;

const AgentPhoto = styled.img`
  max-width: 100%;
`;

const AgentName = styled.div`
  ${typographyHelper('body02Bold')};
`;

const JobTitle = styled.div`
  ${typographyHelper('body02')};
  color: ${paletteHelper('textSecondary')};
`;

const AgentImageCropper = styled.div`
  overflow: hidden;
  width: 50px;
  height: 50px;
  text-align: center;
  border-radius: 50%;
  flex-shrink: 0;
`;

const AgentImagePlaceholder: FunctionComponent = () => {
  return (
    <AgentPhoto
      alt=""
      src="https://s1.rui.au.reastatic.net/rui-static/img/default-profile-image.jpg"
    />
  );
};

export const PropertyTimelineAgent: FunctionComponent<PropertyTimelineAgentProps> = ({
  name,
  jobTitle,
  photo,
}) => {
  return (
    <AgentDetailsContainer>
      <AgentImageCropper>
        {photo ? (
          <picture>
            <source srcSet={photo.webpUri} type="image/webp" />
            <AgentPhoto alt={photo.alt} src={photo.jpgUri} />
          </picture>
        ) : (
          <AgentImagePlaceholder />
        )}
      </AgentImageCropper>
      <AgentInfo>
        <AgentName>{name}</AgentName>
        {jobTitle && <JobTitle>{jobTitle}</JobTitle>}
      </AgentInfo>
    </AgentDetailsContainer>
  );
};
